import React from 'react';
import './add project.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon } from "mdbreact";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { DatePicker, message, TreeSelect } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import moment from 'moment';
const { TreeNode } = TreeSelect;


class AddProject extends React.Component {
    state = {
        name_en: '',
        name_ar: '',
        description_en: '',
        description_ar: '',
        profileUrl: '',
        tag: '',
        img: null,
        imgType: 'data',
        imgName: '',
        employees: [],
        users: [],
        totalPrice: 0,
        supportEmployee: null,
        targetSales: [{ monthDate: null, ratio: 0, target: 0 }],
        totalViews: 0,
        ownerName: '',
        ownerPhone: '',
        ownerPassword: ''
    };

    constructor(props) {
        super(props)
        window.scrollTo(0, 0)
        this.getUserWithoutPagenation()
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
    }

    componentDidMount() {
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
    }
    getUserWithoutPagenation = () => {
        axios.get(`${BASE_END_POINT}quickSearch/get?type=SUB-ADMIN`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en',
            },
        }).then(response => {
            console.log(response.data.data)
            this.setState({ users: response.data.data })
        })
            .catch(error => {
                console.log("ALL users ERROR")
                console.log(error.response)
            })
    }
    add = () => {
        const { profileUrl, name_en, name_ar, description_en, description_ar, tag, img, imgType, employees, totalPrice, supportEmployee,
            ownerName, ownerPhone, ownerPassword, totalViews
        } = this.state
        if (hasValue(name_en) && hasValue(name_ar) && hasValue(description_en) && hasValue(description_ar) && hasValue(tag) && hasValue(ownerName) && hasValue(ownerPhone) && hasValue(ownerPassword) && img != null) {
            let l = message.loading('Wait..', 2.5)
            let data = new FormData()
            data.append('name_en', name_en)
            data.append('name_ar', name_ar)
            data.append('description_en', description_en)
            data.append('description_ar', description_ar)
            data.append('profileUrl', profileUrl)
            data.append('tag', tag)
            data.append('totalViews', totalViews)
            data.append('ownerName', ownerName)
            data.append('ownerPhone', ownerPhone)
            data.append('ownerPassword', ownerPassword)
            data.append('totalPrice', totalPrice)
            data.append('employees', JSON.stringify(employees))
            if (supportEmployee) data.append('supportEmployee', supportEmployee)
            if (img != null && imgType === "data") {
                data.append('img', img)
            }
            let targetSales = this.state.targetSales
                .filter(e => e && e.monthDate)
                .map(e => ({
                    monthDate: moment(e.monthDate, [
                        moment.ISO_8601,
                        "dddd D MMMM YYYY hh:mm A"
                    ]).locale('en').format("YYYY-MM-DD"),
                    ratio: Number(e.ratio) || 0,
                    target: Number(e.target) || 0
                }))
                .filter((obj, index, self) =>
                    index === self.findIndex(o => o.monthDate === obj.monthDate)
                );

            if (targetSales.length > 0) {
                data.append('targetSales', JSON.stringify(targetSales))
            }

            console.log(Array.from(data))
            axios.post(`${BASE_END_POINT}projects`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${this.props.currentUser.token}`,
                    'Accept-Language': this.props.isRTL ? 'ar' : 'en'
                },
            })
                .then(response => {
                    console.log("project UPDATED  ", response.data)
                    l.then(() => message.success(allStrings.done, 2.5))
                    this.props.history.goBack()
                })
                .catch(error => {
                    console.log(error.response)
                    l.then(() => message.error(error.response.data.errors[0].msg, 2.5))
                })
        }
    }



    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
        this.add()
    };

    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
        if (event.target.name === "totalPrice") {
            let targetSales = this.state.targetSales
            let newTargetSales = []
            for (const val of targetSales) {
                newTargetSales.push({
                    monthDate: val.monthDate,
                    ratio: val.ratio,
                    target: (val.ratio * event.target.value) / 100
                })
            }
            this.setState({ targetSales: newTargetSales })
        }
    };
    fileChangedHandler = event => {
        this.setState({
            img: event.target.files[0],
            imgName: event.target.files[0].name,
            imgType: "data"
        })
    }
    removeFile = () => {
        this.setState({
            img: null,
            imgName: '',
            imgType: "url"
        });
    }
    theTargetSales() {
        return this.state.targetSales.map((v, i) =>
            <MDBRow>
                <MDBCol md="2">
                    {i > 0 &&
                        <div className="minusInput" onClick={() => this.removeOptionsInput(i)}>
                            <MDBIcon icon="trash" className="mr-2" />
                        </div>
                    }
                    {i === this.state.targetSales.length - 1 &&
                        <div className="addInputInner" onClick={() => this.setState(prevState => ({ targetSales: [...prevState.targetSales, { option_en: '', option_ar: '' }] }))}>
                            <MDBIcon icon="plus" className="mr-2" />
                        </div>
                    }
                </MDBCol>
                <MDBCol md="3">
                    <div className="md-form">
                        <label htmlFor="form2" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.ratio}</label>
                        <input value={v.ratio} disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }}
                            type="number" id="form2" min={0} name="ratio" className="form-control"
                            onChange={(event) => {
                                let targetSales = [...this.state.targetSales];
                                targetSales[i].ratio = event.target.value;
                                targetSales[i].target = (event.target.value / 100) * this.state.totalPrice;
                                this.setState({ targetSales });
                            }} required validate placeholder="أدخل النسبة..." />
                        <div class="valid-feedback">{allStrings.correct}</div>
                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                    </div>
                </MDBCol>
                <MDBCol md="3">
                    <div className="md-form">
                        <label htmlFor="form2" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.targetDeals}</label>
                        <input value={v.target} disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }}
                            type="number" id="form2" min={0} name="target" className="form-control"
                            onChange={(event) => {
                                let targetSales = [...this.state.targetSales];
                                targetSales[i].target = event.target.value;
                                targetSales[i].ratio = (event.target.value / this.state.totalPrice) * 100;
                                targetSales[i].ratio = Math.floor(targetSales[i].ratio * 10) / 10;
                                this.setState({ targetSales });
                            }} required validate placeholder="أدخل الهدف..." />
                        <div class="valid-feedback">{allStrings.correct}</div>
                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                    </div>
                </MDBCol>
                <MDBCol md="4">
                    <div className="md-form">
                        <label htmlFor="form2" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%', marginBottom: '10px' }}>{allStrings.date}</label>
                        <DatePicker
                            dropdownAlign={{ points: ['bl', 'tl'] }}
                            placement="topLeft"
                            showTime={{ use12Hours: true, format: 'h:mm A' }}
                            style={{ width: '100%', marginTop: '8px', textAlign: this.props.isRTL ? 'right' : 'left', marginBottom: '1rem' }}
                            onChange={(date, dateString) => {
                                console.log(dateString)
                                let targetSales = [...this.state.targetSales];
                                targetSales[i].monthDate = dateString;
                                this.setState({ targetSales });
                            }}
                            placeholder={allStrings.date}
                        />
                    </div>
                </MDBCol>
            </MDBRow>

        )
    }

    removeOptionsInput = (i) => {
        let targetSales = [...this.state.targetSales];
        console.log(i)
        targetSales.splice(i, 1);
        console.log("targetSales", targetSales)
        this.setState({ targetSales });
    }
    render() {
        console.log("type", this.state.type)
        if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('PROJECTS')) return <Redirect to='/Home' />

        return (
            <div className="App">
                <MDBContainer>
                    <MDBRow>
                        <MDBCol md="12">
                            <div className="infoCard">
                                <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                                    <CardMedia
                                        style={{ height: "0px" }}
                                    />
                                    <CardHeader></CardHeader>
                                    <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                                        <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                                            <span className="material-icons" style={{ color: 'white', fontSize: 23 }}>spa</span>
                                        </div>
                                        <div className="tableTitle" style={{
                                            display: 'inline-block', marginTop: '-60px',
                                            marginLeft: '0', marginRight: '0'
                                        }}>
                                            <p>{allStrings.add}</p>
                                        </div>
                                    </div>
                                    <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                                        <MDBContainer>

                                            <MDBRow>
                                                <MDBCol md="12">
                                                    <form
                                                        className="needs-validation"
                                                        onSubmit={this.submitHandler}
                                                        noValidate
                                                    >

                                                        <div className="grey-text">
                                                            <MDBRow>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishName}</label>
                                                                        <input onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9-,.@%$؟'"?#*&()_^&!\\/\s-_]/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.name_en} type="text" id="form645" name="name_en" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل الاسم بالانجليزية..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form56" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicName}</label>
                                                                        <input onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^\u0600-\u06FF0-9\u0660-\u0669#.,@?؟%$_^*()/\\ _-]+/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.name_ar} type="text" id="form56" name="name_ar" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل الاسم بالعربية..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            <MDBRow>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.tag}</label>
                                                                        <input placeholder="أدخل الاسم بالعربية..." disabled={this.state.actionType === "VIEW" ? true : false} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9-,.@%$؟'"?#*&()_^&!\\/\s-_]/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.tag} type="text" id="form645" name="tag" className="form-control" onChange={this.changeHandler} required validate />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.totalPrice}</label>
                                                                        <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.totalPrice} type="number" min={0} id="form645" name="totalPrice" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل السعر الإجمالي..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            <MDBRow>
                                                                <MDBCol md="12">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.profileUrl}</label>
                                                                        <input placeholder="أدخل رابط البروفايل..." disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.profileUrl} type="text" id="form645" name="profileUrl" className="form-control" onChange={this.changeHandler} required validate />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            <MDBRow>
                                                                <MDBCol md="12">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form920" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishDescription}</label>
                                                                        <br></br>
                                                                        <textarea onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9-,.@%$؟'"?#*&()_^&!\\/\s-_]/g, '')} name="description_en" style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="form920" className="form-control" required validate onChange={this.changeHandler} defaultValue={this.state.description_en} placeholder="أدخل الوصف بالانجليزية..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            <MDBRow>
                                                                <MDBCol md="12">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form90" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicDescription}</label>
                                                                        <br></br>
                                                                        <textarea onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^\u0600-\u06FF0-9\u0660-\u0669#.,@?؟%$_^*()/\\ _-]+/g, '')} name="description_ar" style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="form90" className="form-control" required validate onChange={this.changeHandler} defaultValue={this.state.description_ar} placeholder="أدخل الوصف بالعربية..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                                <MDBCol md="6">
                                                                    <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.supportEmployee}</label>
                                                                    <TreeSelect virtual={false}
                                                                        showSearch={true}
                                                                        value={this.state.supportEmployee}
                                                                        disabled={this.state.actionType === "VIEW" ? true : false}
                                                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                                                        treeCheckable={false}
                                                                        treeNodeFilterProp="title"
                                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                                        placeholder={allStrings.supportEmployee}
                                                                        onChange={(value) => {
                                                                            console.log(value)
                                                                            this.setState({ 'supportEmployee': value })
                                                                        }}
                                                                    >
                                                                        {this.state.users.map(val => (
                                                                            <TreeNode value={val.id} title={val.fullname} key={val.id} />
                                                                        ))}
                                                                    </TreeSelect>
                                                                </MDBCol>
                                                                <MDBCol md="6">
                                                                    <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.employees}</label>
                                                                    <TreeSelect virtual={false}
                                                                        showSearch={true}
                                                                        value={this.state.employees}
                                                                        disabled={this.state.actionType === "VIEW" ? true : false}
                                                                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                                                        treeCheckable={true}
                                                                        treeNodeFilterProp="title"
                                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                                        placeholder={allStrings.employees}
                                                                        onChange={(value) => {
                                                                            console.log(value)
                                                                            this.setState({ 'employees': value })
                                                                        }}

                                                                    >
                                                                        {this.state.users.map(val => (
                                                                            <TreeNode value={val.id} title={val.fullname} key={val.id} />
                                                                        ))}
                                                                    </TreeSelect>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            <MDBRow>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.ownerName}</label>
                                                                        <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.ownerName} type="text" id="form645" name="ownerName" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل البيانات..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.ownerPhone}</label>
                                                                        <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.ownerPhone} type="text" id="form645" name="ownerPhone" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل البيانات..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            <MDBRow>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.password}</label>
                                                                        <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.ownerPassword} type="text" id="form645" name="ownerPassword" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل كلمة المرور..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                                <MDBCol md="6">
                                                                    <div className="md-form">
                                                                        <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.totalViews}</label>
                                                                        <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.totalViews} type="number" min={0} id="form645" name="totalViews" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل الرقم..." />
                                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                                    </div>
                                                                </MDBCol>
                                                            </MDBRow>
                                                            <label className="labelBox" style={{ textAlign: this.props.isRTL ? 'right' : 'left', margin: '25px 0px' }}>
                                                                <span>{allStrings.targetSales}</span>
                                                            </label>
                                                            {this.theTargetSales()}
                                                            <MDBRow>
                                                                <MDBCol md="12">
                                                                    <div className="fileUpload2">
                                                                        <input key={this.state.img} type='file' className="upImgs2" onChange={this.fileChangedHandler} ></input>
                                                                        <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.upload}</span></span>
                                                                    </div>
                                                                    <div className="preview">
                                                                        {this.state.img &&
                                                                            <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                                                                                <img alt="" src={URL.createObjectURL(this.state.img)} className="previewImg2" />

                                                                                <span className="imgName">{this.state.imgName}</span>
                                                                                <MDBIcon icon="trash" className="mr-2 removeImg2"
                                                                                    onClick={() => this.removeFile()}  ></MDBIcon>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </MDBCol>
                                                            </MDBRow>
                                                        </div>
                                                        <br></br>
                                                        <br></br>
                                                        <div className="text-center">
                                                            <MDBBtn
                                                                style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff' }}
                                                                rounded
                                                                color="#1D9598"
                                                                type="submit"
                                                                className="btn-block z-depth-1a"
                                                            >
                                                                <MDBIcon icon="plus" className="mr-2" />
                                                                {allStrings.add}
                                                            </MDBBtn>

                                                        </div>
                                                    </form>
                                                </MDBCol>
                                            </MDBRow>
                                        </MDBContainer>
                                    </CardContent>
                                </Card>
                            </div>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>

            </div>
        )
    }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(AddProject)
);